
<div class="font-selection" [formGroup]="fontSelection">

  <div class="font-selection__header">
    <mat-icon>text_fields</mat-icon>
    <h3>Typografi</h3>
  </div>
  <!-- HEADER FONT -->
  <div class="font-row">

    <mat-form-field appearance="outline" class="font-family-field">
      <mat-label>Header font</mat-label>

      <input
        matInput
        type="text"
        formControlName="searchHeader"
        [matAutocomplete]="autoHeader"
        [style.font-family]="currentHeaderFont?.family">

      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <mat-autocomplete #autoHeader="matAutocomplete">
      @for (option of (fontsHeader$ | async); track option) {
        <mat-option
          [value]="option.family"
          (onSelectionChange)="pickFont('header-font', option)">
          {{ option.family }}
        </mat-option>
      }
    </mat-autocomplete>

    <mat-form-field appearance="outline" class="font-weight-field">
      <mat-label>Weight</mat-label>

      <mat-select formControlName="currentHeaderWeight">
        @for (weight of weightValues; track weight) {
          <mat-option [value]="weight">
            {{ weight }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

  </div>

  <!-- BODY FONT -->
  <div class="font-row">

    <mat-form-field appearance="outline" class="font-family-field">
      <mat-label>Body font</mat-label>

      <input
        matInput
        type="text"
        formControlName="searchBody"
        [matAutocomplete]="autoBody"
        [style.font-family]="currentBodyFont?.family">

      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <mat-autocomplete #autoBody="matAutocomplete">
      @for (option of (fontsBody$ | async); track option) {
        <mat-option
          [value]="option.family"
          (onSelectionChange)="pickFont('body-font', option)">
          {{ option.family }}
        </mat-option>
      }
    </mat-autocomplete>

    <mat-form-field appearance="outline" class="font-weight-field">
      <mat-label>Weight</mat-label>

      <mat-select formControlName="currentBodyWeight">
        @for (weight of weightValues; track weight) {
          <mat-option [value]="weight">
            {{ weight }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

  </div>

  <!-- BUTTON FONT -->
  <div class="font-row">

    <mat-form-field appearance="outline" class="font-family-field">
      <mat-label>Button font</mat-label>

      <input
        matInput
        type="text"
        formControlName="searchButton"
        [matAutocomplete]="autoButton"
        [style.font-family]="currentButtonFont?.family">

      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <mat-autocomplete #autoButton="matAutocomplete">
      @for (option of (fontsButton$ | async); track option) {
        <mat-option
          [value]="option.family"
          (onSelectionChange)="pickFont('button-font', option)">
          {{ option.family }}
        </mat-option>
      }
    </mat-autocomplete>

    <mat-form-field appearance="outline" class="font-weight-field">
      <mat-label>Weight</mat-label>

      <mat-select formControlName="currentButtonWeight">
        @for (weight of weightValues; track weight) {
          <mat-option [value]="weight">
            {{ weight }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

  </div>

</div>
